import { useState } from 'react';
import { FaFileUpload } from 'react-icons/fa';
import { useCSVReader, lightenDarkenColor, formatFileSize } from 'react-papaparse';

const GREY = '#CCC';
const GREY_LIGHT = 'rgba(255, 255, 255, 0.4)';
const DEFAULT_REMOVE_HOVER_COLOR = '#A01919';
const REMOVE_HOVER_COLOR_LIGHT = lightenDarkenColor(
  DEFAULT_REMOVE_HOVER_COLOR,
  40
);
const GREY_DIM = '#686868';

const styles = {
  zone: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    cursor: 'pointer',
    padding: 20,
  },
  file: {
    background: 'linear-gradient(to bottom, #EEE, #DDD)',
    display: 'flex',
    height: 120,
    width: 120,
    position: 'relative',
    zIndex: 10,
    flexDirection: 'column',
    justifyContent: 'center',
  },
  info: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: 10,
    paddingRight: 10,
  },
  size: {
    backgroundColor: GREY_LIGHT,
    marginBottom: '0.5em',
    justifyContent: 'center',
    display: 'flex',
  },
  name: {
    backgroundColor: GREY_LIGHT,
    fontSize: 12,
    marginBottom: '0.5em',
  },
  progressBar: {
    bottom: 14,
    position: 'absolute',
    width: '100%',
    paddingLeft: 10,
    paddingRight: 10,
  },
  zoneHover: {
    borderColor: GREY_DIM,
  },
  default: {
    borderColor: GREY,
  },
  remove: {
    height: 23,
    position: 'absolute',
    right: 6,
    top: 6,
    width: 23,
  }
};

const CSVReader = ({setField}) => {
  const { CSVReader } = useCSVReader();
  const [zoneHover, setZoneHover] = useState(false);
  const [removeHoverColor, setRemoveHoverColor] = useState(
    DEFAULT_REMOVE_HOVER_COLOR
  );

  const acceptUploadHandler = (results) => {
    const departments = []
    results.data.forEach((row) => { //find if first element in row exists in 'departments' array already
      if(departments.map(department => department.name).includes(row[0])) {
        const deptIndex = departments.findIndex(dept => dept.name === row[0]); // get index of departments array that has same name as current row
        departments[deptIndex].members.push({
          title: row[1],
          name: row[2],
          phone: row[3],
          email: row[4]
        })
      } else if (row[0] !== ''){ //if name isn't already in 'departments' array, make a new department with that name and add the member
        departments.push({
          name: `${row[0]}`,
          members: [
            {
              title: row[1],
              name: row[2],
              phone: row[3],
              email: row[4]
            }
          ]
        })
      }
    })
    setField('departments', departments)
    setZoneHover(false);
  }

  const dragOverHandler = (event) => {
    event.preventDefault();
    setZoneHover(true);
  }

  const dragLeaveHandler = (event) => {
    event.preventDefault();
    setZoneHover(false);
  }

  return (
    <CSVReader
      onUploadAccepted={acceptUploadHandler}
      onDragOver={dragOverHandler}
      onDragLeave={dragLeaveHandler}
      noDrag
    >
      {({ getRootProps, acceptedFile, ProgressBar, getRemoveFileProps, Remove }) => (
        <div
          {...getRootProps()}
          style={Object.assign(
            {},
            styles.zone,
            zoneHover && styles.zoneHover
          )}
        >
          {acceptedFile ? (
            <div style={styles.file}>
              <div style={styles.info}>
                <span style={styles.size}>
                  {formatFileSize(acceptedFile.size)}
                </span>
                <span style={styles.name}>{acceptedFile.name}</span>
              </div>
              <div style={styles.progressBar}>
                <ProgressBar />
              </div>
              <div
                {...getRemoveFileProps()}
                style={styles.remove}
                onMouseOver={(event: Event) => {
                  event.preventDefault();
                  setRemoveHoverColor(REMOVE_HOVER_COLOR_LIGHT);
                }}
                onMouseOut={(event: Event) => {
                  event.preventDefault();
                  setRemoveHoverColor(DEFAULT_REMOVE_HOVER_COLOR);
                }}
              >
                <Remove color={removeHoverColor} />
              </div>
            </div>
          ) : (
            <>
            <FaFileUpload/>
            <ProgressBar/>
            </>
          )}
        </div>
      )}
    </CSVReader>
  );
}

export default CSVReader
